module.exports = __webpack_public_path__ + "static/fonts/iconfont.d58b7c4.eot";


//////////////////
// WEBPACK FOOTER
// ./src/openSurvey/theme/fonts/iconfont.eot
// module id = n4Mm
// module chunks = 1